// src/theme.ts
import { createTheme } from '@mui/material/styles';

// Gradiente sugerido para o header quando primary é Azul Escuro
export const headerGradient =
  'linear-gradient(90deg, #003A70 0%, #4C1D95 60%, #D81B60 100%)';

const theme = createTheme({
  palette: {
    mode: 'light',
    // Azul escuro como principal
    primary: {
      main: '#003A70', // navy Senac-like
      dark: '#002F59',
      light: '#285A8F',
      contrastText: '#FFFFFF',
    },
    // Laranja como secundário
    secondary: {
      main: '#F37021',
      dark: '#D55E14',
      contrastText: '#FFFFFF',
    },
    // Azul claro "accent"
    info: { main: '#2D9CDB' },

    // Cores de feedback
    success: { main: '#22C55E' },
    warning: { main: '#F59E0B' },
    error: { main: '#E11D48' },

    // Neutros / superfícies
    background: { default: '#F8FAFC', paper: '#FFFFFF' },
    divider: '#E2E8F0',
    text: { primary: '#0F172A', secondary: '#475569' },
  },

  // -> Todo o sistema "quadrado"
  shape: { borderRadius: 0 },

  typography: {
    // Sanchez como fonte global
    fontFamily: 'Sanchez, Arial, sans-serif',
    h1: { fontWeight: 700, letterSpacing: 0.2 },
    h2: { fontWeight: 700, letterSpacing: 0.2 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700, letterSpacing: 0.2 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { lineHeight: 1.8 },
    body2: { lineHeight: 1.7 },
    button: { textTransform: 'none', fontWeight: 600 },
  },

  components: {
    // AppBar sem bordas arredondadas + gradiente
    MuiAppBar: {
      styleOverrides: {
        root: { borderRadius: 0 },
        colorPrimary: {
          background: headerGradient,
        },
      },
    },

    // Papers quadrados
    MuiPaper: {
      defaultProps: { elevation: 1 },
      styleOverrides: {
        root: { borderRadius: 0 },
      },
    },

    // Botões (mantive leve arredondamento; troque para 0 se quiser tudo reto)
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10 },
        containedPrimary: { color: '#FFFFFF' },
        outlined: { borderColor: '#E2E8F0' },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: { borderColor: '#E2E8F0' },
      },
    },
  },
});

export default theme;